module.exports = __webpack_public_path__ + "img/logo-cp.cefdb8c8.svg";